// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { AdminTimeCategory } from './admin-time-category';
import { TimeEntryType } from './time-entry-type';

/// <code-import> Place custom imports between <code-import> tags
export type TimeCategoryFlags = 'Internal' | 'RequiresApproval';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeCategory extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  hasFlag(flag: TimeCategoryFlags): boolean {
    const flags = this.parseFlags();
    return flags.some((f) => f === flag);
  }

  setFlag(flag: TimeCategoryFlags): void {
    if (this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.push(flag);
    this.flags = flags.join(', ') || '0';
  }

  clearFlag(flag: TimeCategoryFlags): void {
    if (!this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.splice(flags.indexOf(flag), 1);
    this.flags = flags.join(', ') || '0';
  }

  private parseFlags(): string[] {
    const flags = this.flags || '0'; // Could be numeric zero
    if (flags === '0') {
      return [];
    }
    return flags.split(',').map((flag) => flag.trim());
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  code?: string;
  createdAt!: Date;
  createdBy?: string;
  description?: string;
  displayOrder!: number;
  flags!: string;
  level!: number;
  locationId!: number;
  parentId?: number;
  subTypeCodeId?: number;
  taxCodeId?: number;
  timeEntryTypeId!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  adminTimeCategories!: AdminTimeCategory[];
  childTimeCategories!: TimeCategory[];
  parentTimeCategory!: TimeCategory;
  timeEntryType!: TimeEntryType;
}

